import React, { useContext, useEffect, useState } from 'react';
import { Button } from 'primereact/button';
import { Dialog } from 'primereact/dialog';
import { downloadCgu, updateCgu } from './service/CdmGlobalService';
import { I18n } from 'aws-amplify';
import { StructureContext } from './structure-context';
import PropTypes from 'prop-types';
import { Carousel } from 'primereact/carousel';
import { useAuthenticator } from '@aws-amplify/ui-react';
const germanFlag = `${process.env.PUBLIC_URL}/assets/layout/images/de-flag.png`;
const frenchFlag = `${process.env.PUBLIC_URL}/assets/layout/images/fr-flag.png`;

const cguUrlsPromisesByKey = new Map();

Cgu.propTypes = {
    cguFiles: PropTypes.array.isRequired,
    locale: PropTypes.string.isRequired
}

function Cgu(props) {

    const [visible, setVisible] = useState(true);
    const [cgu, setCgu] = useState([]);
    const structure = useContext(StructureContext);
    const [index, setIndex] = useState(0);
    const { signOut } = useAuthenticator((context) => [context.user]);
    const [loading, setLoading] = useState(false);
    const [version, setVersion] = useState(() => props.locale === "de" ? "_de" : "_fr");
    const [flag, setFlag] = useState(() => props.locale === "de" ? germanFlag : frenchFlag);

    useEffect(() => {
        let isCancelled = false;
        if (props.cguFiles.length > 0) {
            getCguUrls().then(cguUrls => {
                if (!isCancelled) {
                    setCgu(cguUrls);
                }
            });
        } else {
            setCgu([]);
        }

        return () => {
            isCancelled = true;
        };
        //eslint-disable-next-line
    }, [version])

    useEffect(() => {
        if (index === props.cguFiles.length) {
            setVisible(false);
            window.location.reload();
        }
        //eslint-disable-next-line
    }, [index])

    const getCguUrls = async () => {
        const files = props.cguFiles.map(file => file.concat(version).concat('.pdf'));
        const cguFilesKey = files.join('|');
        if (!cguUrlsPromisesByKey.has(cguFilesKey)) {
            const cguUrlsPromise = Promise.all(files.map(async (file) => {
                return downloadCgu(file);
            }));
            cguUrlsPromisesByKey.set(cguFilesKey, cguUrlsPromise);
        }

        return cguUrlsPromisesByKey.get(cguFilesKey);
    }

    const onCguAccept = () => {
        setLoading(true);
        updateCgu(props.cguFiles[index], structure.id).then(cgu => {
            setIndex(index + 1);
            setLoading(false);
        }).catch(err => {
            setLoading(false);
            console.error(err);
        });
    }

    const itemTemplate = (item) => {
        return <iframe title="CGU" src={item} style={{ width: '100%', height: '100%', border: 'none' }}></iframe>
    }

    const onClickFlag = () => {
        setFlag(flag === frenchFlag ? germanFlag : frenchFlag);
        setVersion(version === "_fr" ? "_de" : "_fr");
    }

    const headerTemplate = () => {
        return (
            <div className="flex flex-row align-items-center justify-content-between w-full" style={{ alignItems: "center" }}>
                <span className="font-bold" style={{ whiteSpace: "nowrap" }}>
                    {I18n.get("cgu")}
                    {props.cguFiles.length > 1 && (
                        <span>&nbsp;{`${index + 1} / ${props.cguFiles.length}`}</span>
                    )}
                </span>
                <div className="flex flex-row align-items-center pr-6" style={{ gap: "0.75rem" }}>
                    <span style={{ whiteSpace: "nowrap" }}>Version :</span>
                    <button className="p-link" onClick={onClickFlag} style={{ padding: 0, border: 'none', background: 'none', display: 'flex', alignItems: 'center' }}>
                        <img src={flag} alt="" style={{ height: '1.8rem', width: '1.8rem' }} />
                    </button>
                </div>
            </div>
        );
    }

    return cgu !== null && (
        <Dialog
            visible={visible}
            header={headerTemplate()}
            onHide={() => { if (!visible) return; }}
            className="w-8 h-full"
            closable={false}
        >
            <Carousel
                value={cgu}
                numVisible={1}
                numScroll={1}
                orientation="vertical"
                verticalViewPortHeight="70vh"
                className="w-full h-8"
                itemTemplate={itemTemplate}
                page={index}
                showNavigators={false}
                showIndicators={false}
            />
            <div className='flex align-items-center justify-content-end pt-2'>
                {props.cguFiles.length > 1 && <span className="font-bold mr-4">{index < props.cguFiles.length ? index + 1 : 1} / {props.cguFiles.length}</span>}
                <Button outlined severity="danger" label={I18n.get("refuser")} onClick={() => { signOut(); }} className="mr-2" disabled={loading} />
                <Button outlined severity="success" label={I18n.get("accepter")} onClick={() => { onCguAccept(); }} disabled={loading} />
            </div>
        </Dialog>
    )
}

export default Cgu;